import { render } from "./FishkeepingDemo.vue?vue&type=template&id=25e55f4b&scoped=true"
import script from "./FishkeepingDemo.vue?vue&type=script&lang=js"
export * from "./FishkeepingDemo.vue?vue&type=script&lang=js"

import "./FishkeepingDemo.vue?vue&type=style&index=0&id=25e55f4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e55f4b"]])

export default __exports__